export const Toggle = ({ l, on, fn, c, sub }) => (
  <div role="button" tabIndex={0} onClick={() => fn(!on)}
    onKeyDown={(e) => e.key === "Enter" && fn(!on)}
    style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer", padding: "12px 0", userSelect: "none" }}>
    <div style={{
      width: 44, height: 26, borderRadius: 13,
      background: on ? c.blue : c.border,
      transition: "background 0.3s cubic-bezier(0.34,1.56,0.64,1)",
      position: "relative", flexShrink: 0,
    }}>
      <div style={{
        width: 22, height: 22, borderRadius: 11, background: "#fff",
        position: "absolute", top: 2, left: on ? 20 : 2,
        transition: "left 0.3s cubic-bezier(0.34,1.56,0.64,1)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
      }} />
    </div>
    <div>
      <span style={{ fontSize: 14, fontWeight: 500, color: c.fg }}>{l}</span>
      {sub && <div style={{ fontSize: 11, color: c.muted, marginTop: 1 }}>{sub}</div>}
    </div>
  </div>
);
